export interface OrganizationEnums {
  projectTypes: string[];
  taskTypes: string[];
  taskPriorities: string[];
  taskStatuses: string[];
}

export const DEFAULT_ORGANIZATION_ENUMS: OrganizationEnums = {
  projectTypes: [
    'software',
    'video',
    'design',
    'portal',
    'consulting',
    'maintenance',
    'development',
    'testing',
    'other',
  ],
  taskTypes: ['development', 'video', 'design', 'testing', 'maintenance', 'consultation'],
  taskPriorities: ['low', 'medium', 'high', 'urgent'],
  taskStatuses: ['Not Started', 'In progress', 'Pending', 'Completed', 'On Hold'],
};

export const ENUM_LABELS: Record<keyof OrganizationEnums, string> = {
  projectTypes: 'Project Types',
  taskTypes: 'Task Types',
  taskPriorities: 'Task Priorities',
  taskStatuses: 'Task Statuses',
};

export function formatEnumLabel(value: string): string {
  if (!value) return value;
  return value
    .split(/[\s_-]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
